// extracted by mini-css-extract-plugin
export default {"clickable":"TableItem_clickable__M-aLc","iconLabelContainer":"TableItem_iconLabelContainer__ATFSF","label":"TableItem_label__NHXrM"};